/**
 * Plain-words helpers for the follow-up panel (pending queue and missed
 * calls): the age badge, and what a lead's row says.
 */
import type { WcFollowUpLead } from '@/services/whatconvertsService';

export const SEVERITY_BADGE: Record<WcFollowUpLead['severity'], string> = {
  ok: 'border-border bg-muted/50 text-muted-foreground',
  amber: 'border-amber/40 bg-amber-light text-amber-dark',
  red: 'border-destructive/40 bg-destructive/10 text-destructive',
};

export function ageText(days: number | null | undefined): string {
  if (days == null) return 'age unknown';
  if (days === 0) return 'today';
  return `${days} ${days === 1 ? 'day' : 'days'}`;
}

/** Short line under a queued lead: why it is waiting and who said so. */
export function pendingLine(lead: WcFollowUpLead): string {
  if (lead.source === 'wc_mark') {
    return lead.reason
      ? `Marked Pending in WhatConverts. ${lead.reason}`
      : 'Marked Pending in WhatConverts.';
  }
  return lead.reason ?? 'Waiting on a decision.';
}

export function leadTitle(lead: WcFollowUpLead): string {
  return lead.contact_name?.trim() || `Lead #${lead.lead_id}`;
}
